import { safeReturnTo } from '../../pages/Delivery/Registries/returnTo';
import { registryHref } from '../../pages/Registries/registryHref';
const TAB = {
    company: 'companies',
    vehicle: 'vehicles',
    contact: 'contacts',
    govorg: 'govorgs',
    lcat_anchor: 'lcats',
    lcat_entry: 'lcats'
};
const FULL_PAGE_KIND = {
    company: 'COMPANY',
    vehicle: 'VEHICLE',
    contact: 'CONTACT',
    govorg: 'GOVERNMENT_ORG',
    lcat_anchor: 'LCAT_ANCHOR',
    lcat_entry: 'LCAT_ENTRY'
};
/**
 * Deep link into the Registries record for a shared identity. `origin` (path +
 * search) becomes returnTo only when the Registries validator accepts it, so a
 * bad origin yields a link with no Back rather than an unsafe one.
 *
 * `fullPage` (REG-08): link to the record's full page instead of the drawer.
 * Callers pass the `registries_records_v1` flag, so flag off is unchanged.
 */ export function registryRecordHref(kind, id, origin, opts) {
    if (opts?.fullPage) {
        const href = registryHref({
            kind: FULL_PAGE_KIND[kind],
            id
        }, origin);
        if (href) return href;
    }
    const base = `/registries?tab=${TAB[kind]}&record=${encodeURIComponent(id)}`;
    const returnTo = safeReturnTo(origin);
    return returnTo ? `${base}&returnTo=${encodeURIComponent(returnTo)}` : base;
}
/** Existing Labor & Rates view (the view has no name filter to deep-link into). */ export function laborRatesHref(origin) {
    const returnTo = safeReturnTo(origin);
    return `/registries?tab=lcats${returnTo ? `&returnTo=${encodeURIComponent(returnTo)}` : ''}`;
}
/** Rate Book tab, pre-filtered. Every entry point consumes the same observations. */ export function rateBookHref(filter) {
    const q = new URLSearchParams({
        tab: 'rate-book'
    });
    if (filter.company) q.set('company', filter.company);
    if (filter.vehicle) q.set('vehicle', filter.vehicle);
    if (filter.lcat) q.set('lcat', filter.lcat);
    return `/registries?${q.toString()}`;
}
